import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { applicationsQueryKey } from '@services/applications/queries/useApplication'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError' // Added import
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import type { ApplicationDetail, ApplicationWrite } from 'types/api'
import { BaseParams } from 'types/utils'

export function usePatchApplication() {
  const toast = useToast()
  const queryClient = useQueryClient()
  const onError = useOnError() // Added usage
  const { t } = useTranslation('application')

  async function patchApplication({
    id,
    body
  }: BaseParams<ApplicationWrite, 'PATCH'>) {
    if (!id) throw new Error('Application ID is required')
    const res = await apiClient.patch<ApplicationDetail>(
      `${SNA_PREFIX}applications/${id}/`,
      body
    )
    return res.data
  }

  return useMutation({
    mutationFn: patchApplication,
    onSuccess: async () => {
      toast.success({ message: t('toast.applicationUpdated') })

      await queryClient.invalidateQueries({ queryKey: applicationsQueryKey })
    },
    onError // Replaced inline function
  })
}
